import { render, staticRenderFns } from "./CoachChampSvg.vue?vue&type=template&id=8e4618c0&"
import script from "./CoachChampSvg.vue?vue&type=script&lang=js&"
export * from "./CoachChampSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports